import { Component, OnInit, OnDestroy } from "@angular/core";
import { ProductsService } from 'src/app/services';
import {  takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import {ActivatedRoute} from "@angular/router";
import {LoyaltyService} from '../../../services/business/loyalty/loyalty.service';

@Component({
  selector: "app-products-detail",
  templateUrl: "./products-detail.component.html",
  styleUrls: ["./products-detail.component.scss"],
})
export class ProductsDetailComponent implements OnInit, OnDestroy {
  unsubscribe$ = new Subject<void>();

  constructor(private productService: ProductsService, private router: ActivatedRoute, private loyaltyService: LoyaltyService) {}

  isDisabled =  false;
  isELabelDisabled = false;
  id: string;
  barcode: any;
  listCampaignAll: any = [];
  productDetail: any = {};
  ngOnInit() {
    this.id = this.router.snapshot.paramMap.get('id');
    this.barcode = localStorage.getItem('barcode');
    // this.productService.currentManagementStatus
    //   .pipe(takeUntil(this.unsubscribe$))
    //   .subscribe((status) => {
    //     if (status.managementStatus < 0) {
    //       this.isDisabled = true;
    //       this.isShow = 1;
    //       return;
    //     }
    //     if (
    //       !status.roleCode &&
    //       (status.managementStatus === 0 ||
    //         status.managementStatus === 1 ||
    //         status.managementStatus === 2 ||
    //         status.managementStatus === 3)
    //     ) {
    //       this.isDisabled = true;
    //       this.isShow = 2;
    //       return;
    //     }
    //     if (
    //       status.roleCode &&
    //       status.roleCode === "PRODUCT_MASTER" &&
    //       status.managementStatus > 0
    //     ) {
    //       this.isDisabled = false;
    //       this.isShow = 2;
    //       return;
    //     }
    //     if (
    //       status.roleCode &&
    //       status.roleCode === "PRODUCT_DISTRIBUTOR" &&
    //       status.managementStatus > 0
    //     ) {
    //       this.isDisabled = true;
    //       this.isShow = 3;
    //       return;
    //     }
    //   });

    this.productService
      .getById(this.id)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(res => {
        if (res.code === 1 && res.data) {
          this.productDetail = Object.assign({}, res.data);
          // if (res.data.expiredManagementStatus) {
          if (res.data.expiredManagementStatus || (!res.data.expiredManagementStatus && res.data.managementStatus === 8)) {
            this.isDisabled = true;
          }

          if (this.isDisabled || res.data.managementStatus === 7 || (res.data.managementStatus === 6 && res.data.roleCode === 'PRODUCT_DISTRIBUTOR')) {
            this.isELabelDisabled = true;
          }
        }
      });
    this.loadCampaignAll();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  loadCampaignAll() {
    // console.log("barcode", barcode)
    this.loyaltyService.campaignAll(this.barcode || '').subscribe(res => {
      // console.log("res", res);
      if (res && res.code === 1) {
        this.listCampaignAll = res.items || [];
      }
    });
  }
}
